import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVulkraan1 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      d="M27 21H9v8h18zM8 21H7v8h1z"
    />
    <path
      fill="#FFBFA5"
      d="M25 16H15v3h10zM28 29v-8h-3v8z"
    />
    <path
      fill="#FF7842"
      d="M33 21.62v6.75a2.62 2.62 0 0 1-2.62 2.62H28v-12h2.38A2.62 2.62 0 0 1 33 21.62M22.53 10a2.52 2.52 0 0 0-1.9-2.44v1.18h-1.26V7.56a2.52 2.52 0 0 0-1.9 2.44zM27 16H13v-2.27A2.82 2.82 0 0 1 15.91 11h8.18A2.82 2.82 0 0 1 27 13.73zM15 19h10v8.37A4.63 4.63 0 0 1 20.37 32h-.74A4.63 4.63 0 0 1 15 27.37zM25 17.5 15 19v-1.5L25 16zM26.5 29 25 21h1.5l1.5 8z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M15.1 14.94V12.5h1v2.44zM18.03 14.94V12.5h1v2.44zM20.97 14.94V12.5h1v2.44zM23.9 14.94V12.5h1v2.44zM15.5 23v4a4.5 4.5 0 0 0 4.5 4.5v1a5.5 5.5 0 0 1-5.5-5.5v-4zM24.5 23v-4h1v4z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVulkraan1);

export default ForwardRef;
